// URL Constatnts

export class GlobalConstants {

    public static DEFAULT_PAGE_SIZE = 50;

    public static LONG_DATE = 'MMMM d, yyyy';

    public static ABBR_LONG_DATE = 'MMM d, yyyy';

    // Increase this value to dump the redux cache on next load.
    public static CACHE_VERSION = 1;

    public static MainServiceCenter = 'MAIN';
    public static TerreHauteServiceCenter = 'IN';
    
}

/**
 * Analytics Page Names
 */
export class PageNames {

    // Dashboard
    public static readonly DASHBOARD                                 = '[DASHBOARD] Dashboard';

    // Accounting
    public static readonly ACCOUNTING_REPORTS                        = '[ACCOUNTING] Reports';
    public static readonly ACCOUNTING_BILLING_ONLY                   = '[ACCOUNTING] Billing Only';
    // Communications 
    public static readonly COMMUNICATIONS_ACTIVITY_FEED              = '[COMMUNICATIONS] Activity Feed';

    // Ordering
    public static readonly ORDERING_ORDER_LOOKUP                     = '[ORDERING] Order Lookup';
    public static readonly ORDERING_ORDER_QUERY                      = '[ORDERING] Order Query';
    public static readonly ORDERING_CREDIT_HOLD                      = '[ORDERING] Credit Hold';
    public static readonly ORDERING_ENGINEERING_REVIEW               = '[ORDERING] Engineering Review';
    public static readonly ORDERING_WINDLOAD_REVIEW                  = '[ORDERING] Windload Review';
    public static readonly ORDERING_CUSTOMER_SERVICE_REVIEW          = '[ORDERING] Customer Service Review';

    // Inventory
    public static readonly INVENTORY_PHYSICAL_LIST                   = '[INVENTORY] List';
    public static readonly INVENTORY_PHYSICAL_DETAILS                = '[INVENTORY] Details';
    public static readonly INVENTORY_PHYSICAL_CONTROL_GROUPS         = '[INVENTORY] Control Groups';
    public static readonly INVENTORY_PHYSICAL_CONTROL_GROUP_ENTRY    = '[INVENTORY] Data Entry';
    public static readonly INVENTORY_PHYSICAL_SHIPMENTS              = '[INVENTORY] Shipments';
    public static readonly INVENTORY_PHYSICAL_REPORT                 = '[INVENTORY] Report';

    //  Invoicing
    public static readonly ACCOUNTING_ACTIVITY_FEED                  = '[ACCOUNTING] Activity Feed';
    public static readonly ACCOUNTING_INVOICE_REQUEST_DETAILS        = '[ACCOUNTING] Invoice Request Details';

    // Production
    public static readonly PRODUCTION_GROUPS_LIST                    = '[PRODUCTION] Groups List';
    public static readonly PRODUCTION_GROUP_DETAILS                  = '[PRODUCTION] Group Details';
    public static readonly PRODUCTION_PLANNING                       = '[PRODUCTION] Planning';
    public static readonly PRODUCTION_PLANNING_ORDERS                = '[PRODUCTION] Planning Orders';
    public static readonly PRODUCTION_PLANNING_SHIPMENTS            = '[PRODUCTION] Planning Shipments';
    public static readonly PRODUCTION_SCHEDULE_CDOEM                       = '[PRODUCTION] Schedule (CD/OEM)';
    public static readonly PRODUCTION_SCHEDULE_RS                    = '[PRODUCTION] Schedule (RS)';
    public static readonly PRODUCTION_REPORTS                        = '[PRODUCTION] Reports';

    // Transportation
    public static readonly TRANSPORTATION_TRUCK_LIST                 = '[TRANSPORTATION] Truck List';
    public static readonly TRANSPORTATION_TRUCK_DETAILS              = '[TRANSPORTATION] Truck Details';
    public static readonly TRANSPORTATION_TRUCK_COD_INFO             = '[TRANSPORTATION] Truck COD Info';
    public static readonly TRANSPORTATION_PICKUP_LIST                = '[TRANSPORTATION] Pickup List';
    public static readonly TRANSPORTATION_PICKUP_DETAIL              = '[TRANSPORTATION] Pickup Detail';
    public static readonly TRANSPORTATION_CONTAINER_LIST             = '[TRANSPORTATION] Container List';
    public static readonly TRANSPORTATION_CONTAINER_DETAIL           = '[TRANSPORTATION] Container Detail';
    public static readonly TRANSPORTATION_PLANNING                   = '[TRANSPORTATION] Planning';
    public static readonly TRANSPORTATION_PLANNING_DELIVERIES        = '[TRANSPORTATION] Planning Deliveries';
    public static readonly TRANSPORTATION_PLANNING_CONTAINERS        = '[TRANSPORTATION] Planning Containers';
    public static readonly TRANSPORTATION_PLANNING_ORDER_LIST        = '[TRANSPORTATION] Planning Order List';
    public static readonly TRANSPORTATION_PLANNING_IMPORT            = '[TRANSPORTATION] Planning Import';
    public static readonly TRANSPORTATION_FLEET                      = '[TRANSPORTATION] Fleet';
    public static readonly TRANSPORTATION_FLEET_ASSETS               = '[TRANSPORTATION] Fleet Assets';
    public static readonly TRANSPORTATION_FLEET_ASSETS_DETAILS       = '[TRANSPORTATION] Fleet Asset Details';
    public static readonly TRANSPORTATION_FLEET_DRIVERS              = '[TRANSPORTATION] Fleet Drivers';
    public static readonly TRANSPORTATION_FLEET_DRIVERS_DETAILS      = '[TRANSPORTATION] Fleet Driver Details';
    public static readonly TRANSPORTATION_COMMUNICATIONS             = '[TRANSPORTATION] Communications';
    public static readonly TRANSPORTATION_TRUCK_COMMUNICATIONS       = '[TRANSPORTATION] Truck Communications';
    public static readonly TRANSPORTATION_CONTAINER_COMMUNICATIONS   = '[TRANSPORTATION] Container Communications';
    public static readonly TRANSPORTATION_ADDRESSES                  = '[TRANSPORTATION] Addresses Pending Approval';
    
    // Support
    public static readonly SUPPORT_USERS_LIST                        = '[SUPPORT] Users List';
    public static readonly SUPPORT_USER_DETAILS                      = '[SUPPORT] User Details';
    public static readonly SUPPORT_USER_CREATE                       = '[SUPPORT] User Create';
    public static readonly SUPPORT_DEALERS_LIST                      = '[SUPPORT] Dealers List';
    public static readonly SUPPORT_DEALERS_DETAILS                   = '[SUPPORT] Dealer Details';
    public static readonly SUPPORT_DEALERS_CREDITS                   = '[SUPPORT] Dealer Credits';
    public static readonly SUPPORT_ACTIVITY_FEED                     = '[SUPPORT] Activity Feed';
    public static readonly SUPPORT_SYNC_ORDERS                       = '[SUPPORT] Sync Orders';

    // Reports
    public static readonly REPORTS_MAIN                              = '[REPORTS] Report List';

}

/**
 * Constants used for route matching by the router.
 *
 * Every page lives at /{section}/{page}, which is also where its source is: src/pages/{section}/{page}
 */
export class Routes {

    // #region Dashboard Routes

    // The home page, so it has no section
    public static readonly DASHBOARD                         = '/';

    // #endregion

    // #region Reports Routes

    public static readonly REPORTS                           = '/reports';

        public static readonly REPORTS_REPORTS                   = `${ Routes.REPORTS }/reports`;

    // #endregion

    // #region Ordering Routes

    public static readonly ORDERING                          = '/ordering';

        public static readonly ORDERING_LOOKUP                   = `${ Routes.ORDERING }/order-lookup`;
        public static readonly ORDERING_ORDERS                   = `${ Routes.ORDERING }/orders`;
        public static readonly ORDERING_BACKORDER                = `${ Routes.ORDERING }/backorder`;
        public static readonly ORDERING_SYNC                     = `${ Routes.ORDERING }/sync`;

    // #endregion

    // #region Approvals Routes

    public static readonly APPROVALS                         = '/approvals';

        public static readonly APPROVALS_CREDIT_HOLD             = `${ Routes.APPROVALS }/credit-hold`;
        public static readonly APPROVALS_ENGINEERING             = `${ Routes.APPROVALS }/engineering`;
        public static readonly APPROVALS_WINDLOAD                = `${ Routes.APPROVALS }/windload`;
        public static readonly APPROVALS_CUSTOMER_SERVICE        = `${ Routes.APPROVALS }/customer-service`;
        public static readonly APPROVALS_ADDRESSES               = `${ Routes.APPROVALS }/addresses`;

    // #endregion

    // #region Routing Routes

    public static readonly ROUTING                           = '/routing';

        public static readonly ROUTING_ROUTING                   = `${ Routes.ROUTING }/routing`;

            public static readonly ROUTING_ROUTING_IMPORT            = `${ Routes.ROUTING_ROUTING }/import`;
            public static readonly ROUTING_ROUTING_PICKUPS           = `${ Routes.ROUTING_ROUTING }/pickups`;
            public static readonly ROUTING_ROUTING_DELIVERIES        = `${ Routes.ROUTING_ROUTING }/deliveries`;

            public static readonly ROUTING_ROUTING_PLANNING          = `${ Routes.ROUTING_ROUTING }/planning`;

    // #endregion

    // #region Production Routes

    public static readonly PRODUCTION                        = '/production';

        public static readonly PRODUCTION_SCHEDULE_CDOEM                  = `${ Routes.PRODUCTION }/schedule-cdoem`;
        public static readonly PRODUCTION_SCHEDULE_RS               = `${ Routes.PRODUCTION }/schedule-rs`;
        public static readonly PRODUCTION_PAPERWORK                 = `${ Routes.PRODUCTION }/paperwork`;
        public static readonly PRODUCTION_PAPERWORK_SEARCH          = `${ Routes.PRODUCTION }/paperwork/search`;
        public static readonly PRODUCTION_LINES                     = `${ Routes.PRODUCTION }/lines`;
        public static readonly PRODUCTION_PLANNING                  = `${ Routes.PRODUCTION }/planning`;
        public static readonly PRODUCTION_PLANNING_ORDERS           = `${ Routes.PRODUCTION }/planning/orders`;
        public static readonly PRODUCTION_PLANNING_SHIPMENTS       = `${ Routes.PRODUCTION }/planning/shipments`;

    // #endregion

    // #region Shipping Routes

    public static readonly SHIPPING                                                      = '/shipping';

        // Fedex
        public static readonly SHIPPING_FEDEX                                            = `${ Routes.SHIPPING }/fedex`;

        // Pickup List
        public static readonly SHIPPING_PICKUPS                                          = `${ Routes.SHIPPING }/pickups`;

            // Edit
            public static readonly SHIPPING_PICKUP_EDIT                                  = `${ Routes.SHIPPING_PICKUPS }/edit`;
            public static readonly SHIPPING_PICKUP_EDIT_ROUTE                            = `${ Routes.SHIPPING_PICKUP_EDIT }/:id?`;
            public static readonly SHIPPING_PICKUP_EDIT_WITH_ID                          = `${ Routes.SHIPPING_PICKUP_EDIT }/{0}`;
        
        // Delivery List
        public static readonly SHIPPING_TRUCKS                                           = `${ Routes.SHIPPING }/trucks`;

            // Edit 
            public static readonly SHIPPING_TRUCK_EDIT                                   = `${ Routes.SHIPPING_TRUCKS }/edit`;
            public static readonly SHIPPING_TRUCK_EDIT_ROUTE                             = `${ Routes.SHIPPING_TRUCK_EDIT }/:id?`;
            public static readonly SHIPPING_TRUCK_EDIT_WITH_ID                           = `${ Routes.SHIPPING_TRUCK_EDIT }/{0}`;
            public static readonly SHIPPING_TRUCK_EDIT_SCHEDULE_ROUTE                    = `${ Routes.SHIPPING_TRUCK_EDIT_ROUTE }/schedule`;
            public static readonly SHIPPING_TRUCK_EDIT_SCHEDULE                          = `${ Routes.SHIPPING_TRUCK_EDIT_WITH_ID }/schedule`;
            public static readonly SHIPPING_TRUCK_EDIT_ORDERS_ROUTE                      = `${ Routes.SHIPPING_TRUCK_EDIT_ROUTE }/orders`;
            public static readonly SHIPPING_TRUCK_EDIT_ORDERS                            = `${ Routes.SHIPPING_TRUCK_EDIT_WITH_ID }/orders`;
            public static readonly SHIPPING_TRUCK_EDIT_COD_ROUTE                         = `${ Routes.SHIPPING_TRUCK_EDIT_ROUTE }/cod`;
            public static readonly SHIPPING_TRUCK_EDIT_COD                               = `${ Routes.SHIPPING_TRUCK_EDIT_WITH_ID }/cod`;

        // Container List
        public static readonly SHIPPING_CONTAINERS                                       = `${ Routes.SHIPPING }/containers`;
        
            // Edit
            public static readonly SHIPPING_CONTAINER_EDIT                               = `${ Routes.SHIPPING_CONTAINERS }/edit`;
            public static readonly SHIPPING_CONTAINER_EDIT_ROUTE                         = `${ Routes.SHIPPING_CONTAINER_EDIT }/:id?`;
            public static readonly SHIPPING_CONTAINER_EDIT_WITH_ID                       = `${ Routes.SHIPPING_CONTAINER_EDIT }/{0}`;

        // Fleet
        public static readonly SHIPPING_FLEET                                            = `${ Routes.SHIPPING }/fleet`;

            public static readonly SHIPPING_FLEET_ASSETS                                 = `${ Routes.SHIPPING_FLEET }/assets`;
            public static readonly SHIPPING_FLEET_ASSETS_EDIT                            = `${ Routes.SHIPPING_FLEET_ASSETS }/edit`;
            public static readonly SHIPPING_FLEET_ASSETS_EDIT_ROUTE                      = `${ Routes.SHIPPING_FLEET_ASSETS }/edit/:id?`;
            public static readonly SHIPPING_FLEET_ASSETS_EDIT_WITH_ID                    = `${ Routes.SHIPPING_FLEET_ASSETS_EDIT }/{0}`;

            public static readonly SHIPPING_FLEET_DRIVERS                                = `${ Routes.SHIPPING_FLEET }/drivers`;            
            public static readonly SHIPPING_FLEET_DRIVERS_EDIT                           = `${ Routes.SHIPPING_FLEET_DRIVERS }/edit`;
            public static readonly SHIPPING_FLEET_DRIVERS_EDIT_ROUTE                     = `${ Routes.SHIPPING_FLEET_DRIVERS_EDIT }/:id?`;
            public static readonly SHIPPING_FLEET_DRIVERS_EDIT_WITH_ID                   = `${ Routes.SHIPPING_FLEET_DRIVERS_EDIT }/{0}`;

    // #endregion

    // #region Invoicing Routes

    public static readonly INVOICING                         = '/invoicing';

        public static readonly INVOICING_TEST_REQUEST            = `${ Routes.INVOICING }/test-request`;
        public static readonly INVOICING_REPORTS                 = `${ Routes.INVOICING }/reports`;
        public static readonly INVOICING_CREDITS                 = `${ Routes.INVOICING }/credits`;
        public static readonly INVOICING_INVOICES                = `${ Routes.INVOICING }/invoices`;
        public static readonly INVOICING_BILLING_ONLY            = `${ Routes.INVOICING }/billing-only`;

        // Activity Feed
        public static readonly INVOICING_ACTIVITY_FEED           = `${ Routes.INVOICING }/activity-feed`;

        // Acitivty Feed Details
        public static readonly INVOICING_ACTIVITY_FEED_DETAILS             = `${ Routes.INVOICING_ACTIVITY_FEED }/details`;
        public static readonly INVOICING_ACTIVITY_FEED_DETAILS_ROUTE       = `${ Routes.INVOICING_ACTIVITY_FEED_DETAILS }/:id`;
        public static readonly INVOICING_ACTIVITY_FEED_DETAILS_WITH_ID     = `${ Routes.INVOICING_ACTIVITY_FEED_DETAILS }/{0}`;

    // #endregion

    // #region Communications Routes

    public static readonly COMMUNICATIONS                    = '/communications';

        public static readonly COMMUNICATIONS_SHIPMENTS           = `${ Routes.COMMUNICATIONS }/shipments`;

            public static readonly COMMUNICATIONS_SHIPMENTS_TRUCKS        = `${ Routes.COMMUNICATIONS_SHIPMENTS }/trucks`
            public static readonly COMMUNICATIONS_SHIPMENTS_CONTAINERS    = `${ Routes.COMMUNICATIONS_SHIPMENTS }/containers`

        public static readonly COMMUNICATIONS_MAIL_TRIAGE        = `${ Routes.COMMUNICATIONS }/mail-triage`;
        public static readonly COMMUNICATIONS_ACTIVITY_FEED      = `${ Routes.COMMUNICATIONS }/activity-feed`;

    // #endregion

    // #region Inventory Routes

    public static readonly INVENTORY                        = '/inventory';

        public static readonly INVENTORY_PHYSICAL                               = `${Routes.INVENTORY}/physical`;

        public static readonly INVENTORY_PHYSICAL_DETAILS                       = `${Routes.INVENTORY_PHYSICAL}/details/{0}`;
        public static readonly INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE            = `${Routes.INVENTORY_PHYSICAL}/details/:id`;

        public static readonly INVENTORY_PHYSICAL_DETAILS_CONTROLGROUPS         = `${Routes.INVENTORY_PHYSICAL_DETAILS}/controlgroups`;
        public static readonly INVENTORY_PHYSICAL_DETAILS_CONTROLGROUPS_ROUTE   = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/controlgroups`;
        public static readonly INVENTORY_PHYSICAL_HORIZONTAL_ENTRIES_ROUTE      = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/controlgroups/entries/horizontal/:controlNumber/:entryId`;
        public static readonly INVENTORY_PHYSICAL_HORIZONTAL_ENTRIES            = `${Routes.INVENTORY_PHYSICAL_DETAILS}/controlgroups/entries/horizontal/{1}/{2}`;
        public static readonly INVENTORY_PHYSICAL_VERTICAL_ENTRIES_ROUTE        = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/controlgroups/entries/vertical/:controlNumber/:entryId`;
        public static readonly INVENTORY_PHYSICAL_VERTICAL_ENTRIES              = `${Routes.INVENTORY_PHYSICAL_DETAILS}/controlgroups/entries/vertical/{1}/{2}`;        
        public static readonly INVENTORY_PHYSICAL_DETAILS_CONFLICTS             = `${Routes.INVENTORY_PHYSICAL_DETAILS}/conflicts/{1}`;
        public static readonly INVENTORY_PHYSICAL_DETAILS_CONFLICTS_ROUTE       = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/conflicts/:controlNumber`;

        public static readonly INVENTORY_PHYSICAL_DETAILS_SHIPMENTS             = `${Routes.INVENTORY_PHYSICAL_DETAILS}/shipments`;
        public static readonly INVENTORY_PHYSICAL_DETAILS_SHIPMENTS_ROUTE       = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/shipments`;

        public static readonly INVENTORY_PHYSICAL_DETAILS_ORDERS                = `${Routes.INVENTORY_PHYSICAL_DETAILS}/orders`;
        public static readonly INVENTORY_PHYSICAL_DETAILS_ORDERS_ROUTE          = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/orders`;

        public static readonly INVENTORY_PHYSICAL_DETAILS_ADJUSTMENTS           = `${Routes.INVENTORY_PHYSICAL_DETAILS}/adjustments`;
        public static readonly INVENTORY_PHYSICAL_DETAILS_ADJUSTMENTS_ROUTE     = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/adjustments`;

        public static readonly INVENTORY_PHYSICAL_DETAILS_REPORT                = `${Routes.INVENTORY_PHYSICAL_DETAILS}/report`;
        public static readonly INVENTORY_PHYSICAL_DETAILS_REPORT_ROUTE          = `${Routes.INVENTORY_PHYSICAL_DETAILS_WITH_ROUTE}/report`;

    // #endregion

    // #region Support Routes

    public static readonly SUPPORT                           = '/support';

        // User List
        public static readonly SUPPORT_USERS                     = `${ Routes.SUPPORT }/users`;

        // Dealers List
        public static readonly SUPPORT_DEALERS                   = `${ Routes.SUPPORT }/dealers`;
        public static readonly SUPPORT_DEALERS_WITH_ID               = `${ Routes.SUPPORT_DEALERS }/{0}`;
        public static readonly SUPPORT_DEALERS_WITH_ROUTE            = `${ Routes.SUPPORT_DEALERS }/:id`;

        // Edit User
        public static readonly SUPPORT_USER_EDIT                 = `${ Routes.SUPPORT_USERS }/edit`;
        public static readonly SUPPORT_USER_EDIT_WITH_ID             = `${ Routes.SUPPORT_USER_EDIT }/{0}`;
        public static readonly SUPPORT_USER_EDIT_ROUTE               = `${ Routes.SUPPORT_USER_EDIT }/:id?`;
        public static readonly SUPPORT_USER_PREFERENCES              = `${ Routes.SUPPORT_USERS }/preferences`;

        // Activity Feed
        public static readonly SUPPORT_ACTIVITY_FEED             = `${ Routes.SUPPORT }/activity`;

        // Dev Workbench
        public static readonly SUPPORT_DEV                       = `${ Routes.SUPPORT }/dev`;
            
    // #endregion

    // #region Utility Routes

    public static readonly UTILITY                           = '/utility';

        public static readonly UTILITY_FORBIDDEN                 = `${ Routes.UTILITY }/forbidden`;
        public static readonly UTILITY_NOT_READY                 = `${ Routes.UTILITY }/not-ready`;
        public static readonly UTILITY_NOT_FOUND                 = `${ Routes.UTILITY }/not-found`;

    // #endregion

}

/**
 * Constants for Api Endpoints
 */
export class ApiEndpoints {

    /**
     * The address of an endpoint for one kind of shipment. Trucks and containers are served at /trucks and /containers,
     * and the constants that serve both name them {shipments}.
     * @param endpoint One of the constants with {shipments} in it
     * @param type The kind of shipment: 0 for a truck, 1 for a container (ShipmentType)
     */
    public static shipment(endpoint: string, type: number): string {
        if (type !== 0 && type !== 1) {
            throw new Error(`There is no address for a shipment of type ${ type }`);
        }

        return endpoint.replace('{shipments}', type === 1 ? '/containers' : '/trucks');
    }

    //
    // Session Endpoints
    //
        public static readonly ACCOUNT_SESSION                                      = '/session';

    //
    // Dashboard Endpoints
    //
        public static readonly DASHBOARD_WAITING                                    = '/dashboard/waiting';
        public static readonly DASHBOARD_SINGLEWIDES                                = '/dashboard/singlewides';
        public static readonly DASHBOARD_ENTERED                                    = '/dashboard/entered';

    //
    // Inventory Endpoints
    //
        public static readonly INVENTORY_PHYSICAL_REPORTS                           = '/inventory/reports';
        public static readonly INVENTORY_PHYSICAL_REPORT_DETAILS                    = '/inventory/reports/{0}';
        public static readonly INVENTORY_PHYSICAL_CREATE_REPORT                     = '/inventory/reports?date={0}&name={1}';
        public static readonly INVENTORY_BOOK                                       = '/inventory/reports/{0}/book';
        public static readonly INVENTORY_DATA                                       = '/inventory/reports/{0}/data';
        public static readonly INVENTORY_FINAL_SUMMARY                              = '/inventory/reports/{0}/final-summary';
        public static readonly INVENTORY_PHYSICAL_REFRESH_PRICING                   = '/inventory/reports/{0}/refresh-pricing';
        public static readonly INVENTORY_PHYSICAL_FINALIZE                          = '/inventory/reports/{0}/finalize';

        public static readonly INVENTORY_CONFLICTS                                  = '/inventory/reports/{0}/conflicts/{1}';
        public static readonly INVENTORY_PHYSICAL_CONTROL_GROUP_ENTRY               = '/inventory/reports/{0}/control-groups/{1}/entries/{2}';
        public static readonly INVENTORY_PHYSICAL_RESOLVE_CONFLICTS                 = '/inventory/reports/{0}/conflicts';
        public static readonly INVENTORY_PARTS_AUTOCOMPLETE                         = '/inventory/reports/{0}/parts/lookup?query';

        public static readonly INVENTORY_PHYSICAL_SHIPMENTS                        = '/inventory/reports/{0}/shipments';

        public static readonly INVENTORY_PHYSICAL_ORDERS                           = '/inventory/reports/{0}/orders';

        public static readonly INVENTORY_PHYSICAL_ADJUSTMENTS                      = '/inventory/reports/{0}/adjustments';

        public static readonly INVENTORY_FINAL_REPORT                              = '/inventory/reports/{0}/final-report';


    //
    // Accounting Endpoints
    //

        public static readonly ACCOUNTING_INVOICES_QUERY                         = '/invoices';
        public static readonly ACCOUNTING_INVOICES_EXPORT                        = '/invoices/export';
        public static readonly ACCOUNTING_INVOICES_TOTALS_QUERY                  = '/invoices/totals';
        public static readonly ACCOUNTING_INVOICES_REPORT                        = '/invoices/{0}/report';
        public static readonly ACCOUNTING_INVOICES_SUMMARY                       = '/invoices/{0}/summary';
        public static readonly ACCOUNTING_ACCOUNTMATE_REPORT                     = '/reports/accountmate-financials?startDate={0}&endDate={1}';
        public static readonly ACCOUNTING_CREDIT                                 = '/credits';
        public static readonly ACCOUNTING_CREDIT_REASONS                         = '/credits/reasons';
        public static readonly ACCOUNTING_CREDIT_CATEGORIES                      = '/credits/categories';
        public static readonly ACCOUNTING_CREDIT_REPORT                          = '/reports/credit-summary?from={0}&to={1}';
        public static readonly ACCOUNTING_INVOICE_ORDER                          = '/orders/{0}/invoice';
        public static readonly ACCOUNTING_OPEN_ORDERS                            = '/reports/open-orders';
        public static readonly ACCOUNTING_MONTHLY_INVOICE_REPORT                 = '/reports/monthly-invoice?startDate={0}&endDate={1}';
        public static readonly ACCOUNTING_TAX_BREAKDOWN_REPORT                   = '/reports/tax-breakdown?startDate={0}&endDate={1}';

    //
    // MiscEndpoints
    //
        public static readonly MISCELLANEOUS_PAYROLL_COMPARISON_REPORT           = '/reports/payroll-comparison';
        
    //
    // Communication
    //

        // Message Endpoints
        public static readonly COMMUNICATION_MESSAGE_QUERY                       = '/messages';
        public static readonly COMMUNICATION_MESSAGE_RESEND                      = '/messages/{0}/resend';
        public static readonly COMMUNICATION_MESSAGE_DOCUMENT                    = '/messages/{0}/document';

        // MailJob Endpoints
        public static readonly COMMUNICATION_MAILJOB                             = '/mail-jobs';
        public static readonly COMMUNICATION_MAILJOB_PRINT                       = '/mail-jobs/{0}/done';
        public static readonly COMMUNICATION_MAILJOB_SUMMARY                     = '/mail-jobs/summary';
        public static readonly COMMUNICATION_MAILJOB_DOCUMENT                    = '/mail-jobs/{0}/document';
        public static readonly COMMUNICATION_MAILJOB_QUERY                       = '/mail-jobs?status={0}';
    
    //
    // Dealers Endpoints
    //

        public static readonly DEALER_SEARCH                                     = '/dealers';
        public static readonly DEALERS_BY_ID                                     = '/dealers/{0}';
        public static readonly DEALERS_AUTOCOMPLETE                              = '/dealers/lookup?query';
        public static readonly DEALER_CREDIT_SEARCH                              = '/dealers/{0}/credits';
        public static readonly DEALERS_SALES                                     = '/dealers/{0}/sales';
        public static readonly DEALERS_EXPORT                                    = '/dealers/export';
        public static readonly DEALERS_STATEMENT                                 = '/reports/dealer-statement?dealerId={0}'  

    //
    // Production Endpoints
    //

        public static readonly PRODUCTION_SCHEDULE_ALL                                   = '/production/schedule';
        public static readonly PRODUCTION_SCHEDULE_CDOEM                             = '/production/schedule/cdoem';
        public static readonly PRODUCTION_SCHEDULE_RS                                = '/production/schedule/rs';
        public static readonly PRODUCTION_METRICS_ORDERS                            = '/production/metrics/orders';
        public static readonly PRODUCTION_METRICS_ORDERS_DETAILS                      = '/production/metrics/orders/details';
        public static readonly PRODUCTION_METRICS_SHIPMENTS                         = '/production/metrics/shipments';
        public static readonly PRODUCTION_METRICS_SHIPMENTS_ORDERS                  = '/production/metrics/shipments/orders?shipmentId={0}';
        public static readonly PRODUCTION_RUN_CREATE_FOR_ORDERS                          = '/production/runs';
        public static readonly PRODUCTION_RUN_CREATE_FOR_ORDER_IDS                      = '/production/runs';
        public static readonly PRODUCTION_RUN_CREATE_FOR_SHIPMENT                        = '/production/runs';
        public static readonly PRODUCTION_RUN                                        = '/production/runs/{0}';
        public static readonly PRODUCTION_RUN_GET_RANKINGS                           = '/production/rankings?quantity={0}';
        public static readonly PRODUCTION_RUN_CANCEL                                 = '/production/runs/{0}/cancel';
        public static readonly PRODUCTION_RUN_COMPLETE                               = '/production/runs/{0}/complete';
        public static readonly PRODUCTION_RUN_UPDATE_RANK                            = '/production/runs/{0}/rank';
        public static readonly PRODUCTION_RUN_PAPERWORK                              = '/production/runs/{0}/paperwork';
        public static readonly PRODUCTION_SINGLE_REPORT                              = '/reports/single-paperwork';
        public static readonly PRODUCTION_RUN_ORDERS                                 = '/production/runs/{0}/orders';
        public static readonly PRODUCTION_RUN_JOB_PRINT                              = '/production/jobs/{0}/printed';
        public static readonly PRODUCTION_RUN_JOB_COMPLETE                           = '/production/jobs/{0}/completed';
        public static readonly PRODUCTION_JOBS_DOWNLOAD                              = '/production/paperwork/by-line';
        public static readonly PRODUCTION_ORDER_ERRORS                               = '/reports/order-errors';
        public static readonly WINDLOAD_CHECKLIST_REPORT                             = '/reports/windload-checklist';
        public static readonly FULLVIEW_EXPORT                                       = '/reports/fullview-export';

        public static readonly PRODUCTION_METRICS_ORDERS_GROUPS                      = '/production/metrics/orders/groups';
        public static readonly PRODUCTION_METRICS_ORDERS_EXPORT                      = '/production/metrics/orders/export';
        public static readonly PRODUCTION_METRICS_SHIPMENTS_EXPORT                    = '/production/metrics/shipments/export';
        public static readonly PRODUCTION_SCHEDULE_CDOEM_EXPORT                            = '/production/schedule/cdoem/export';

        
    //
    // Mediator Endpoints    
    //

        public static readonly MEDIATOR_ORDER_SYNC                               = '/mediator/orders/{0}/sync';

    //
    // Ordering Endpoints     
    //
    
        public static readonly ORDERING_ORDER_BY_ID                              = '/orders/{0}';
        public static readonly ORDERING_ORDER_HISTORY_BY_ID                      = '/orders/{0}/history';
        public static readonly ORDERING_BACKORDER                                = '/orders/{0}/backorder';
        public static readonly ORDERING_ORDER_QUERY                              = '/orders';
        public static readonly ORDERING_SEARCH_EXPORT                            = '/orders/export';
        public static readonly ORDERING_CREDIT_HOLD                              = '/approvals/credit-hold/summary';
        public static readonly ORDERING_CREDIT_HOLD_DETAILS                      = '/approvals/credit-hold/details';
        public static readonly ORDERING_CREDIT_HOLD_APPROVE                      = '/approvals/credit-hold/approve';
        public static readonly ORDERING_CREDIT_HOLD_AGING                        = '/dealers/{0}/aging-report';
        public static readonly ORDERING_CREDIT_HOLD_AGING_EXPORT                 = '/dealers/{0}/aging-report/export';
        public static readonly ORDERING_ENGINEERING_REVIEW                       = '/approvals/engineering/summary';
        public static readonly ORDERING_ENGINEERING_REVIEW_EXPORT                = '/approvals/engineering/export';
        public static readonly ORDERING_WINDLOAD_REVIEW                          = '/approvals/windload/summary';
        public static readonly ORDERING_WINDLOAD_REVIEW_EXPORT                   = '/approvals/windload/export';
        public static readonly ORDERING_CUSTOMER_SERVICE_REVIEW                  = '/approvals/customer-service/summary';
        public static readonly ORDERING_CUSTOMER_SERVICE_REVIEW_EXPORT           = '/approvals/customer-service/export';
        public static readonly ORDERING_PICK_LIST_EXPORT                         = '/orders/{0}/pick-list';
        public static readonly ORDERING_SHIP_ORDER                               = '/orders/{0}/ship';

    //
    // Transportation Endpoints
    //

        // Pickups Endpoints
        public static readonly TRANSPORTATION_PICKUPS                            = '/pickups';
        public static readonly TRANSPORTATION_PICKUPS_SEARCH                     = '/pickups';
        public static readonly TRANSPORTATION_PICKUP_BY_ID                       = '/pickups/{0}';
        public static readonly TRANSPORTATION_PICKUP_MARK_DELIVERED              = '/pickups/{0}/deliver';
        public static readonly TRANSPORTATION_PICKUP_ORDERS_BY_DEALER            = '/orders?forPickup=true&dealerId={0}&shippingMethod={1}&skip=0&take=1000';
        public static readonly TRANSPORTATION_PICKUP_PAPERWORK                   = '/pickups/{0}/paperwork';

        // Route Endpoints
        public static readonly TRANSPORTATION_ROUTES                             = '{shipments}';
        public static readonly TRANSPORTATION_ROUTE_BY_ID                        = '{shipments}/{0}';
        public static readonly TRANSPORTATION_ROUTES_NEW_STOP                    = '{shipments}/{0}/stops';
        public static readonly TRANSPORTATION_ROUTES_UPDATE_STOP                 = '{shipments}/{0}/stops/{1}';
        public static readonly TRANSPORTATION_ROUTES_UPDATE_STOP_ADDRESS         = '{shipments}/{0}/stops/{1}/address';
        public static readonly TRANSPORTATION_ROUTES_MARK_STOP_DELIVERED         = '{shipments}/{0}/stops/{1}/deliver';
        public static readonly TRANSPORTATION_ROUTES_SET_SCHEDULE                = '{shipments}/{0}/schedule';
        public static readonly TRANSPORTATION_ROUTES_SET_COD                     = '{shipments}/{0}/cods';
        public static readonly TRANSPORTATION_ROUTES_SET_CUSTOMS                 = '{shipments}/{0}/customs';
        public static readonly TRANSPORTATION_ROUTES_CHANGE_STATUS               = '{shipments}/{0}/status';
        public static readonly TRANSPORTATION_ROUTE_OPTIMIZE                     = '{shipments}/estimate';
        public static readonly TRANSPORTATION_TRUCKS_SEARCH                      = '/trucks';
        public static readonly TRANSPORTATION_CONTAINERS_SEARCH                  = '/containers';
        public static readonly TRANSPORTATION_COMMUNICATIONS_TRUCKS_SEARCH       = '/communications/shipment-notifications';
        public static readonly TRANSPORTATION_COMMUNICTIONS_CONTAINERS_SEARCH    = '/communications/shipment-notifications';
        public static readonly TRANSPORTATION_ROUTES_ADD_ADDON                   = '{shipments}/{0}/stops/{1}/addon';

        // Route Document Endpoints
        public static readonly TRANSPORTATION_ROUTE_PAPERWORK                    = '{shipments}/{0}/documents/paperwork';
        public static readonly TRANSPORTATION_ROUTE_REQUISISTION_DOC             = '{shipments}/{0}/documents/load-requisition';
        public static readonly TRANSPORTATION_ROUTE_RUNLOG_DOC                   = '{shipments}/{0}/documents/run-log';
        public static readonly TRANSPORTATION_ROUTE_RUNLOG_EXCEL_DOC             = '{shipments}/{0}/documents/run-log-export';
        public static readonly TRANSPORTATION_ROUTE_BULK_RUNLOG_DOC              = '{shipments}/documents/run-log?shipmentIds={0}';
        public static readonly TRANSPORTATION_ROUTE_BULK_RUNLOG_EXCEL_DOC        = '{shipments}/documents/run-log-export?shipmentIds={0}';
        public static readonly TRANSPORTATION_ROUTE_BILLOFLADING_DOC             = '{shipments}/{0}/documents/bill-of-lading';
        public static readonly TRANSPORTATION_ROUTE_COMM_INVOICES_DOC            = '{shipments}/{0}/documents/commercial-invoices';
        public static readonly TRANSPORTATION_ROUTE_COMM_INVOICES_EXPORT_DOC     = '{shipments}/{0}/documents/commercial-invoice-export';
        public static readonly TRANSPORTATION_ROUTE_LOADSHEET_DOC                = '{shipments}/{0}/documents/load-sheets';
        public static readonly TRANSPORTATION_ROUTE_DELIVERY_SCHEDULE_DOC        = '{shipments}/{0}/documents/delivery-schedules';
        public static readonly TRANSPORTATION_ROUTE_NOTIFICATIONS_SEND           = '/communications/shipment-notifications';
        public static readonly TRANSPORTATION_ROUTE_SHIPMENT_SCAN                = '{shipments}/{0}/documents/scan-report';
        public static readonly TRANSPORTATION_ROUTE_LOADERREPORT_DOC             = '{shipments}/{0}/documents/loader-report';
    
        // Transportation Address Endpoints
        public static readonly TRANSPORTATION_ADDRESSES_BY_ID                    = '/addresses/{0}';
        public static readonly TRANSPORTATION_ADDRESSES_BY_ID_ADMIN              = '/addresses/{0}/admin';
        public static readonly TRANSPORTATION_ADDRESS_LOCATE                     = '/addresses/locate';
        public static readonly TRANSPORTATION_ADDRESSES_PENDING_APPROVAL         = '/approvals/addresses/{0}';
        public static readonly TRANSPORTATION_ADDRESSES_PENDING_APPROVAL_LIST    = '/approvals/addresses';
        public static readonly TRANSPORTATION_ADDRESSES_UPDATE_FOR_APPROVAL      = '/approvals/addresses/{0}';
        public static readonly TRANSPORTATION_ADDRESSES_APPROVE                  = '/approvals/addresses/{0}/approve';
        public static readonly TRANSPORTATION_ADDRESSES_TOGGLE_REVIEWED          = '/approvals/addresses/{0}/reviewed';

        // Transportation Planning Endpoints       
        public static readonly TRANSPORTATION_PLANNING_ROUTES                    = '/routing/routes';
        public static readonly TRANSPORTATION_PLANNING_IMPORT                    = '/routing/stop-files';
        public static readonly TRANSPORTATION_PLANNING_GROUP_UPDATE              = '/routing/order-groups';
        public static readonly TRANSPORTATION_PLANNING_STOPFILE_V2               = '/routing/stop-files/export';

        // Asset Endpoints
        public static readonly TRANSPORTATION_FLEET_ASSETS                       = '/assets';
        public static readonly TRANSPORTATION_FLEET_ASSETS_SEARCH                = '/assets';
        public static readonly TRANSPORTATION_FLEET_ASSET_BY_ID                  = '/assets/{0}';
        public static readonly TRANSPORTATION_FLEET_VEHICLE_AUTOCOMPLETE_NO_SC   = '/assets/lookup?types=0,2&query';
        public static readonly TRANSPORTATION_FLEET_VEHICLE_AUTOCOMPLETE         = '/assets/lookup?serviceCenterId={0}&types=0,2&query';
        public static readonly TRANSPORTATION_FLEET_TRAILER_AUTOCOMPLETE         = '/assets/lookup?serviceCenterId={0}&types=1&query';

        // Driver Endpoints
        public static readonly TRANSPORTATION_FLEET_DRIVERS                      = '/drivers';
        public static readonly TRANSPORTATION_FLEET_DRIVERS_SEARCH               = '/drivers';        
        public static readonly TRANSPORTATION_FLEET_DRIVER_BY_ID                 = '/drivers/{0}';
        public static readonly TRANSPORTATION_FLEET_DRIVERS_AUTOCOMPLETE         = '/drivers/lookup?serviceCenterId={0}&query';

        // Order Endpoints
        public static readonly TRANSPORTATION_ORDERS_QUERY                       = '/orders';
        public static readonly TRANSPORTATION_PLANNED_ORDERS                     = '/orders?shipToAddressId={0}&shipmentStatus=1&shippingMethod=0&take=10000';

    //
    // Users Endpoints
    //

        public static readonly USER_USERS                                        = '/users';
        public static readonly USER_USERS_BY_ID                                  = '/users/{0}';
        public static readonly USER_USERS_NOTIFICATION_TEST                      = '/notifications/test';
        public static readonly USER_USERS_NOTIFICATION_UPDATE                    = '/notifications/settings';
        public static readonly USER_USERS_NOTIFICATION_TOPICS                    = '/notifications/settings';

    //
    // Customer Address Endpoints
    //
    
        public static readonly DEALERS_TRANSPORTATION_ADDRESSES                  = '/dealers/{0}/addresses';
        public static readonly DEALERS_TRANSPORTATION_OPEN_ADDRESSES             = '/dealers/{0}/addresses?hasOpenOrders=true&serviceCenterId={1}';
        public static readonly DEALERS_CREDIT_REVERSE                            = '/credits/{0}/reverse';
        public static readonly VENDORS_ADDRESSES_BY_ID                           = '/vendors/{0}/addresses';
        public static readonly DEALERS_TRANSPORTATION_CREATE_ADDRESS             = '/dealers/{0}/addresses';

    //
    // Sync Endpoints
    //
        public static readonly SYNC_ORDER_BY_ID                                  = '/orders/{0}/sync';

    //
    // Vendor Endpoints
    //
    
        public static readonly VENDORS_AUTOCOMPLETE                              = '/vendors/lookup?query';

    //
    // Report Endpoints
    //

        public static readonly REPORTS_TRANSPORTATION_SHIPMENTEXPORT             = '/reports/shipment-export?shipmentIds={0}';
        public static readonly REPORTS_TRANSPORTATION_SHIPMENT_METRICS           = '/reports/shipment-metrics?from={0}&to={1}';
        public static readonly REPORTS_PRODUCTION_PRODUCTIONSCHEDULE_REPORT      = '/reports/shipments/productionschedule?start={0}&end={1}';
        public static readonly REPORTS_PRODUCTION_TERREHAUTEPAPERWORK_REPORT     = '/reports/terre-haute-paperwork?runIds={0}';
        public static readonly REPORTS_PRODUCTION_ORDERS_PAPERWORK               = '/reports/order-paperwork?orderIds={0}';
        public static readonly REPORTS_RELEASED_ORDERS_REPORT                    = '/reports/released-orders?start={0}&end={1}';
        public static readonly REPORTS_ROLL_FORMING_PAPERWORK                    = '/reports/roll-forming-paperwork?startDate={0}&endDate={1}';
        public static readonly STICKERS_REPORT                                   = '/reports/stickers';
        public static readonly SHORT_DOOR_REPORT                                 = '/reports/short-door';
        public static readonly CUSTOM_ACCENT_REPORT                              = '/reports/custom-accent';
        public static readonly ENGINEERING_REVIEW_BY_DATE                        = '/reports/engineering-review-by-date?startDate={0}&endDate={1}';

    //
    // Support Activity Endpoints
    //

        public static readonly SUPPORT_ACTIVITY_FEED                             = '/events';
}

export class ScrollStatePaths {

    // Accounting 
    public static readonly ACCOUNTING_INVOICE_REQUEST    = 'accountingInvoiceRequest';

    // Fleet
    public static readonly FLEET_ASSETS                  = 'fleetAssets';
    public static readonly FLEET_DRIVERS                 = 'fleetDrivers';
    
    // Planning
    public static readonly PLANNING_DELIVERY             = 'planningDelivery';
    public static readonly PLANNING_CONTAINER            = 'planningContainer';

    // Shipments
    public static readonly SHIPMENTS_DELIVERIES          = 'shipmentDeliveries';
    public static readonly SHIPMENTS_CONTAINERS          = 'shipmentContainers';
    public static readonly SHIPMENTS_PICKUPS             = 'shipmentPickups';

    // Support
    public static readonly SUPPORT_USERS                 = 'supportUsers';
    
}
